<div class="type-main">
  <div *ngIf="dataIsReady" class="type-main-page1" id="page1">
    <div class="type-cross-container" (click)="cancel()">
      <img class="type-cross-img" src="assets/general/cross-blue.svg" />
    </div>
    <!-- <div class="type-title" [ngStyle]="{'top':isDetail?'86px':'64px'}">نوع برنامه غذایی خود را انتخاب کنید</div>
    <div class="type-personal-title" [ngStyle]="{'top':isDetail?'96px':'88px'}">برنامه غذایی شخصی سازی شده</div>
    <div class="type-personal-holder" (click)="personalSelected()" [ngStyle]="{'top':isDetail?'110px':'104px'}">
      <img class="type-personal-img" src="assets/generate/personalDiet.png">
      <div class="type-personal-left-holder">
        <div class="type-personal-description-holder">
          <div class="type-personal-description" id="personalDescription">
            با چند انتخاب، برنامه غذایی مخصوص خود را دریافت کنید
          </div>
          <div class="type-personal-duration">۳۰ روز</div>
        </div>
        <div class="type-personal-start">شروع کنید</div>
      </div>
    </div>
    <div class="type-predefined-title">برنامه‌های غذایی خاص</div>
    <div class="type-predefined-diet-holder">
      <div
        *ngFor="let predefinedDiet of predefinedDiets; let i = index"
        class="type-predefined-diet"
        [ngStyle]="{ 'margin-top': i === 0 || i === 1 ? '8px' : '0' }"
        (click)="predefinedSelected(predefinedDiet)"
      >
        <img src="{{ predefinedDiet.type.imagePath }}" />
        <div class="type-predefined-diet-title-holder">
          <div class="type-predefined-diet-name">
            {{ predefinedDiet.type.name }}
          </div>
          <div class="type-predefined-diet-duration">
            {{ predefinedDiet.days }} روز
          </div>
        </div>
      </div>
    </div> -->

    <div class="plans-personal-diet" (click)="personalSelected()">
      <img src="{{ personalDiet?.image }}" />
      <div class="plans-personal-title">برنامه غذایی خودت رو بساز</div>
      <div class="plans-personal-bottom-box">
        <img src="assets/plans/plus-white.svg" />
        <div class="plans-personal-bottom-box-title">ساختن برنامه شخصی</div>
        <div class="plans-personal-bottom-box-duration">۳۰ روز</div>
      </div>
    </div>
    <div
      *ngFor="let category of dietsListCategories; let last = last"
      [ngStyle]="{ 'padding-bottom': last ? '24px' : '0' }"
    >
      <div class="plans-category-title">{{ category.name }}</div>
      <div class="plans-diet-type-list">
        <div
          *ngFor="let dietType of category.dietTypes; let last = last"
          class="plans-diet-type"
          [ngStyle]="{ 'margin-left': last ? '16px' : '0' }"
          (click)="dietTypeSelected(dietType)"
        >
          <img src="{{ dietType?.image }}" />
          <div class="plans-diet-type-holder">
            <div class="plans-diet-type-name">{{ dietType.name }}</div>
            <div class="plans-diet-type-duration">{{ dietType.days }} روز</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="type-main-page2" id="page2">
    <div
      class="type-cross-container2"
      (click)="back()"
      [ngStyle]="{ top: isDetail ? '80px' : '8px' }"
    >
      <img class="type-cross-img2" src="assets/general/back-blue.svg" />
    </div>
    <div class="type-holder" style="top: 0; height: calc(100% - 96px)">
      <div class="type-banner">
        <img src="{{ generateShared.selectedDietTypeTemp?.image }}" />
        <div class="type-selected-bottom-box">
          <div class="type-selected-predefined-diet-name">
            {{ generateShared.selectedDietTypeTemp?.name }}
          </div>
        </div>
      </div>
      <div class="type-selected-predefined-diet-title">توضیح</div>
      <div class="type-selected-predefined-diet-description">
        {{ generateShared.selectedDietTypeTemp.description }}
      </div>
    </div>
    <div class="type-submit" (click)="start()">شروع</div>

    <!-- <div *ngIf="dataIsReady && isDetail" class="type-holder" [ngStyle]="{'top':isDetail?'48px':'0', 'height':isDetail?'calc( 100% - 144px )':'calc( 100% - 96px )'}">
      <div class="type-banner" [ngStyle]="{'background':generateShared.selectedDietTypeTemp.id==='0'?'rgb(247, 207, 97)':'white'}">
        <img src={{generateShared.selectedDietTypeTemp.type.imagePath}}>
        <div class="type-selected-predefined-diet-name">{{generateShared.selectedDietTypeTemp.type.name}}</div>
        <div class="type-selected-predefined-diet-duration">{{generateShared.selectedDietTypeTemp.days}} روز</div>
      </div>
    </div>
    <div
      *ngIf="dataIsReady && !isDetail"
      class="type-holder"
      [ngStyle]="{
        top: isDetail ? '48px' : '0',
        height: isDetail ? 'calc( 100% - 144px )' : 'calc( 100% - 96px )'
      }"
    >
      <div
        class="type-banner"
        [ngStyle]="{
          background:
            generateShared.selectedDietType.id === '0'
              ? 'rgb(247, 207, 97)'
              : 'white'
        }"
      >
        <img src="{{ generateShared.selectedDietType.type.imagePath }}" />
        <div class="type-selected-predefined-diet-name">
          {{ generateShared.selectedDietType.type.name }}
        </div>
        <div class="type-selected-predefined-diet-duration">
          {{ generateShared.selectedDietType.days }} روز
        </div>
      </div>
      <div class="type-selected-predefined-diet-description">
        {{ generateShared.selectedDietType.type.description }}
      </div>
    </div>
    <div
      *ngIf="dataIsReady"
      class="type-submit"
      (click)="start()"
      [ngStyle]="{ top: isDetail ? '64px' : '16px' }"
    >
      شروع کنید
    </div>
<<<<<<< HEAD
=======
    <div *ngIf="dataIsReady" class="type-submit" (click)="start()" [ngStyle]="{'top':isDetail?'64px':'16px'}">شروع کنید</div> -->
    >>>>>>> 14-fasting
  </div>
</div>
